import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
import dateUtils from "utils/dateUtils";

import arrayUtils from "utils/newArrayUtils";

export class Store {
    public readonly id: string;
    public readonly outputAreaCode: string;
    public readonly retailCentreID: number;
    public readonly storeCategoryID: number;
    public readonly name: string;
    public readonly group: string;
    public readonly kpmgStoreCategory: string;
    public readonly clientRegion: string;
    public readonly region: string;
    public readonly sizeInSquareFeet: number;
    public readonly format: string;
    public readonly segment: string;
    public readonly locationType: string;
    public readonly openingDate: Date;
    public readonly numberOfEmployees: number;
    public readonly weeklyRevenue: number;
    public readonly yearlyRevenue: number;
    public readonly priorYearRevenue: number;
    public readonly revenuePerSquareFoot: number;
    public readonly revenuePerHead: number;
    public readonly grossProfit: number;
    public readonly grossProfitMargin: number;
    public retailCentreClassificationName: string;
    public changeInNumberOfStores: number;
    public catchmentSize: number;
    public numberOfCompetitors: number;
    public footfallLevel: number;
    public footfallCount: number;
    public readonly openHoursWeek: number;
    public readonly tradingFloors: number;
    public readonly carPark: string;
    public readonly numberOfCarParkSpace: number | null;
    public readonly clickAndCollect: boolean | null;
    public readonly wheelchairAccessible: boolean | null;
    public readonly numberOfMannedTills: number | null;
    public readonly numberOfSelfCheckout: number | null;
    public readonly leaseEndDate: Date | null;
    public readonly lastRefitDate: Date | null;
    public readonly clientCategoryFeature1: string;
    public readonly clientCategoryFeature2: string;
    public readonly clientCategoryFeature3: string;
    public readonly clientCategoryFeature4: string;
    public readonly clientCategoryFeature5: string;
    public readonly clientNumericalFeature1: number | null;
    public readonly clientNumericalFeature2: number | null;
    public readonly clientNumericalFeature3: number | null;
    public readonly clientNumericalFeature4: number | null;
    public readonly clientNumericalFeature5: number | null;
    public readonly clientNumericalFeature6: number | null;
    public readonly clientNumericalFeature7: number | null;
    public readonly clientNumericalFeature8: number | null;
    public readonly clientNumericalFeature9: number | null;
    public readonly clientNumericalFeature10: number | null;
    public readonly clientNumericalFeature11: number | null;
    public readonly clientNumericalFeature12: number | null;
    public readonly clientNumericalFeature13: number | null;
    public readonly clientNumericalFeature14: number | null;
    public readonly clientNumericalFeature15: number | null;

    constructor(
        id: string,
        outputAreaCode: string,
        retailCentreID: number,
        storeCategoryID: number,
        name: string,
        group: string,
        kpmgStoreCategory: string,
        clientRegion: string,
        region: string,
        sizeInSquareFeet: number,
        format: string,
        segment: string,
        locationType: string,
        openingDate: Date,
        numberOfEmployees: number,
        weeklyRevenue: number,
        yearlyRevenue: number,
        priorYearRevenue: number,
        revenuePerSquareFoot: number,
        grossProfit: number,
        grossProfitMargin: number,
        retailCentreClassificationName: string,
        changeInNumberOfStores: number,
        catchmentSize: number,
        numberOfCompetitors: number,
        footfallLevel: number,
        footfallCount: number,
        openHoursWeek: number,
        tradingFloors: number,
        carPark: string,
        numberOfCarParkSpace: number | null,
        clickAndCollect: boolean | null,
        wheelchairAccessible: boolean | null,
        numberOfMannedTills: number | null,
        numberOfSelfCheckout: number | null,
        leaseEndDate: Date | null,
        lastRefitDate: Date | null,
        clientCategoryFeature1: string,
        clientCategoryFeature2: string,
        clientCategoryFeature3: string,
        clientCategoryFeature4: string,
        clientCategoryFeature5: string,
        clientNumericalFeature1: number | null,
        clientNumericalFeature2: number | null,
        clientNumericalFeature3: number | null,
        clientNumericalFeature4: number | null,
        clientNumericalFeature5: number | null,
        clientNumericalFeature6: number | null,
        clientNumericalFeature7: number | null,
        clientNumericalFeature8: number | null,
        clientNumericalFeature9: number | null,
        clientNumericalFeature10: number | null,
        clientNumericalFeature11: number | null,
        clientNumericalFeature12: number | null,
        clientNumericalFeature13: number | null,
        clientNumericalFeature14: number | null,
        clientNumericalFeature15: number | null,
    ) {
        this.id = id;
        this.outputAreaCode = outputAreaCode;
        this.retailCentreID = retailCentreID;
        this.storeCategoryID = storeCategoryID;
        this.name = name;
        this.group = group;
        this.kpmgStoreCategory = kpmgStoreCategory;
        this.clientRegion = clientRegion;
        this.region = region;
        this.sizeInSquareFeet = sizeInSquareFeet;
        this.format = format;
        this.segment = segment;
        this.locationType = locationType;
        this.openingDate = openingDate;
        this.numberOfEmployees = numberOfEmployees;
        this.weeklyRevenue = weeklyRevenue;
        this.yearlyRevenue = yearlyRevenue;
        this.priorYearRevenue = priorYearRevenue;
        this.revenuePerSquareFoot = revenuePerSquareFoot;
        this.revenuePerHead = numberOfEmployees === 0 ? 0 : yearlyRevenue / numberOfEmployees;
        this.grossProfit = grossProfit;
        this.grossProfitMargin = grossProfitMargin;
        this.retailCentreClassificationName = retailCentreClassificationName;
        this.changeInNumberOfStores = changeInNumberOfStores;
        this.catchmentSize = catchmentSize;
        this.numberOfCompetitors = numberOfCompetitors;
        this.footfallLevel = footfallLevel;
        this.footfallCount = footfallCount;
        this.openHoursWeek = openHoursWeek;
        this.tradingFloors = tradingFloors;
        this.carPark = carPark;
        this.numberOfCarParkSpace = numberOfCarParkSpace;
        this.clickAndCollect = clickAndCollect;
        this.wheelchairAccessible = wheelchairAccessible;
        this.numberOfMannedTills = numberOfMannedTills;
        this.numberOfSelfCheckout = numberOfSelfCheckout;
        this.leaseEndDate = leaseEndDate;
        this.lastRefitDate = lastRefitDate;
        this.clientCategoryFeature1 = clientCategoryFeature1;
        this.clientCategoryFeature2 = clientCategoryFeature2;
        this.clientCategoryFeature3 = clientCategoryFeature3;
        this.clientCategoryFeature4 = clientCategoryFeature4;
        this.clientCategoryFeature5 = clientCategoryFeature5;
        this.clientNumericalFeature1 = clientNumericalFeature1;
        this.clientNumericalFeature2 = clientNumericalFeature2;
        this.clientNumericalFeature3 = clientNumericalFeature3;
        this.clientNumericalFeature4 = clientNumericalFeature4;
        this.clientNumericalFeature5 = clientNumericalFeature5;
        this.clientNumericalFeature6 = clientNumericalFeature6;
        this.clientNumericalFeature7 = clientNumericalFeature7;
        this.clientNumericalFeature8 = clientNumericalFeature8;
        this.clientNumericalFeature9 = clientNumericalFeature9;
        this.clientNumericalFeature10 = clientNumericalFeature10;
        this.clientNumericalFeature11 = clientNumericalFeature11;
        this.clientNumericalFeature12 = clientNumericalFeature12;
        this.clientNumericalFeature13 = clientNumericalFeature13;
        this.clientNumericalFeature14 = clientNumericalFeature14;
        this.clientNumericalFeature15 = clientNumericalFeature15;
    }
}

const parseBoolean = (value: string) => value === null ? null : Boolean(value);
const parseDate = (value: string) => value === null ? null : dateUtils.dateUTC(value);
const parseNumber = (value: string) => value === null ? null : Number(value);

export const loadStores = (): AppThunk<Promise<Store[]>> => async (dispatch) => {
    try {
        const storesQuery = {
            segments: [
                "D_Store.OpenPhysicalStores"
            ],
            dimensions: [
                "D_Store.StoreNaturalID",
                "D_Store.StoreName",
                "D_Store.k_Region",
                "D_Store.OutputAreaID",
                "D_Store.Lat",
                "D_Store.Long",
                "D_Store.OpeningDate",
                "D_Store.Sqft",
                "D_Store.EmployeeCount",
                "D_Store.RetailCentreID",
                "D_Store.KPMGStoreCategory",
                "D_Store.StoreCategory_ID",
                "D_Store.Segment",
                "D_Store.LocationType",
                "D_Store.Format",
                "D_Store.Group",
                "D_Store.ClientRegion",
                "D_Store.OpenHoursWeek",
                "D_Store.TradingFloors",
                "D_Store.CarPark",
                "D_Store.NumberOfCarParkSpace",
                "D_Store.ClickAndCollect",
                "D_Store.WheelchairAccessible",
                "D_Store.NumberOfMannedTills",
                "D_Store.NumberOfSelfCheckout",
                "D_Store.LeaseEndDate",
                "D_Store.LastRefitDate",
                "D_Store.ClientCategoryFeature1",
                "D_Store.ClientCategoryFeature2",
                "D_Store.ClientCategoryFeature3",
                "D_Store.ClientCategoryFeature4",
                "D_Store.ClientCategoryFeature5",
                "D_Store.ClientNumericalFeature1",
                "D_Store.ClientNumericalFeature2",
                "D_Store.ClientNumericalFeature3",
                "D_Store.ClientNumericalFeature4",
                "D_Store.ClientNumericalFeature5",
                "D_Store.ClientNumericalFeature6",
                "D_Store.ClientNumericalFeature7",
                "D_Store.ClientNumericalFeature8",
                "D_Store.ClientNumericalFeature9",
                "D_Store.ClientNumericalFeature10",
                "D_Store.ClientNumericalFeature11",
                "D_Store.ClientNumericalFeature12",
                "D_Store.ClientNumericalFeature13",
                "D_Store.ClientNumericalFeature14",
                "D_Store.ClientNumericalFeature15",
                "Store_PerformanceSummary.LTMSales",
                "Store_PerformanceSummary.LTMProfit",
                "Store_PerformanceSummary.PYSales"
            ],
            limit: 50000
        };

        const retailCentresQuery = {
            dimensions: [
                "D_Store.StoreNaturalID",
                "Client_RC_RagMetrics.AreaHealth",
                "Client_RC_RagMetrics.Catchment",
                "Client_RC_RagMetrics.Competition",
                "Client_RC_RagMetrics.Footfall",
                "Client_RC_RagMetrics.FootfallCount",
                "Client_RC_RagMetrics.RetailCentreClassification"
            ],
            segments: [
                "D_Store.OpenPhysicalStores"
            ],
            limit: 50000
        };

        const storesPromise = dispatch(cubeLoad(storesQuery)) as unknown as ResultSet;
        const retailCentresPromise = dispatch(cubeLoad(retailCentresQuery)) as unknown as ResultSet;

        const newResults = await Promise.all([storesPromise, retailCentresPromise]);

        const storesRawData = newResults[0].rawData();
        const retailCentresRawData = newResults[1].rawData();
        const combinedRawData = arrayUtils.arrayJoinOnKey([storesRawData, retailCentresRawData], "D_Store.StoreNaturalID", true);

        const stores = combinedRawData.map(row => {
            const yearlyRevenue = Number(row["Store_PerformanceSummary.LTMSales"]) ?? 0;
            const priorYearRevenue = Number(row["Store_PerformanceSummary.PYSales"]);
            const grossProfitMargin = Number(row["Store_PerformanceSummary.LTMProfit"]) ?? 0;
            return new Store(
                row["D_Store.StoreNaturalID"],
                row["D_Store.OutputAreaID"],
                Number(row["D_Store.RetailCentreID"]),
                Number(row["D_Store.StoreCategory_ID"]),
                row["D_Store.StoreName"],
                row["D_Store.Group"],
                row["D_Store.KPMGStoreCategory"],
                row["D_Store.ClientRegion"],
                row["D_Store.k_Region"],
                Number(row["D_Store.Sqft"]),
                row["D_Store.Format"],
                row["D_Store.Segment"],
                row["D_Store.LocationType"],
                dateUtils.dateUTC(row["D_Store.OpeningDate"]),
                Number(row["D_Store.EmployeeCount"]),
                yearlyRevenue / 52,
                yearlyRevenue,
                priorYearRevenue,
                yearlyRevenue / row["D_Store.Sqft"],
                grossProfitMargin * yearlyRevenue,
                grossProfitMargin,
                row["Client_RC_RagMetrics.RetailCentreClassification"] ?? "",
                Number(row["Client_RC_RagMetrics.AreaHealth"]) ?? 0,
                Number(row["Client_RC_RagMetrics.Catchment"]) ?? 0,
                Number(row["Client_RC_RagMetrics.Competition"]) ?? 0,
                Number(row["Client_RC_RagMetrics.Footfall"]) ?? 0,
                Number(row["Client_RC_RagMetrics.FootfallCount"]) ?? 0,
                Number(row["D_Store.OpenHoursWeek"]),
                Number(row["D_Store.TradingFloors"]),
                row["D_Store.CarPark"],
                parseNumber(row["D_Store.NumberOfCarParkSpace"]),
                parseBoolean(row["D_Store.ClickAndCollect"]),
                parseBoolean(row["D_Store.WheelchairAccessible"]),
                parseNumber(row["D_Store.NumberOfMannedTills"]),
                parseNumber(row["D_Store.NumberOfSelfCheckout"]),
                parseDate(row["D_Store.LeaseEndDate"]),
                parseDate(row["D_Store.LastRefitDate"]),
                row["D_Store.ClientCategoryFeature1"],
                row["D_Store.ClientCategoryFeature2"],
                row["D_Store.ClientCategoryFeature3"],
                row["D_Store.ClientCategoryFeature4"],
                row["D_Store.ClientCategoryFeature5"],
                parseNumber(row["D_Store.ClientNumericalFeature1"]),
                parseNumber(row["D_Store.ClientNumericalFeature2"]),
                parseNumber(row["D_Store.ClientNumericalFeature3"]),
                parseNumber(row["D_Store.ClientNumericalFeature4"]),
                parseNumber(row["D_Store.ClientNumericalFeature5"]),
                parseNumber(row["D_Store.ClientNumericalFeature6"]),
                parseNumber(row["D_Store.ClientNumericalFeature7"]),
                parseNumber(row["D_Store.ClientNumericalFeature8"]),
                parseNumber(row["D_Store.ClientNumericalFeature9"]),
                parseNumber(row["D_Store.ClientNumericalFeature10"]),
                parseNumber(row["D_Store.ClientNumericalFeature11"]),
                parseNumber(row["D_Store.ClientNumericalFeature12"]),
                parseNumber(row["D_Store.ClientNumericalFeature13"]),
                parseNumber(row["D_Store.ClientNumericalFeature14"]),
                parseNumber(row["D_Store.ClientNumericalFeature15"])
            );
        });

        return stores;
    } catch (error) {
        dispatch(logError("Error loading Stores.", error));
        throw error;
    }
};
